import { Component, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

export type ConfirmModalTone = "danger" | "accent";

@Component({
  selector: "app-confirm-modal",
  templateUrl: "./confirm-modal.component.html",
  styleUrls: ["./confirm-modal.component.scss"]
})
export class ConfirmModalComponent {
  @Input() title = "";
  @Input() message = "";
  @Input() detail = "";
  @Input() confirmLabel = "";
  @Input() cancelLabel = "";
  @Input() tone: ConfirmModalTone = "accent";

  constructor(public activeModal: NgbActiveModal) {}
}
